<h2>SEI STUDENTE?</h2>
<p>Che tu sia studente universitario o di scuola superiore, ci sono dei contenuti
	pensati per te. Di seguito trovi due sezioni, ognuna per ogni tipologia di studente;
	consulta quella che più ti interessa e scopri quello che abbiamo preparato per te.
</p>


<p>
	In ogni caso non dimenticare di dare un'occhiata alla pagina
	<a href="https://www.youtube.com/channel/UCTgLUneI3agkv_FcW0RlI0A">
		YouTube</a>, dove pubblichiamo video specifici su <a href="
					https://www.youtube.com/watch?v=c16aoAi-7Bo&list=PLu4yxTVzRRMU93T5hf2mKtVINipn5O69F">
		crittografia post quantum</a>, <a href="https://www.youtube.com/watch?v=
					sbgbtmM6wSY&list=PLu4yxTVzRRMVYZwb9ukJTkUyVN-6bQEsR">Bitcoin</a>, e
	<a href="https://www.youtube.com/channel/UCTgLUneI3agkv_FcW0RlI0A/playlists">
		molto altro!</a>
</p>
<hr>
<h4>UNIVERSITÀ</h4>
<p>
	Se sei uno studente universitario potresti essere interessato, oltre alle iniziative divulgative
	e alle gare a tema (per le quali ti rimandiamo alla sezione sopra), anche a contenuti più specifici.
</p>
<ul>
	<li>La De Cifris offre agli studenti universitari la possibilità di fare
		<a routerLink="/stage-tirocini">stage qualificanti</a>
		presso le aziende che collaborano con l'associazione. Le aziende forniscono anche
		<a routerLink="/advisory-board">borse di studio</a>
		per gli studenti più meritevoli. Scopri di più nella pagina dedicata.
	</li>
	<li>
		Ci sono svariati <a routerLink="/seminari-locali">cicli di seminari</a>,
		di carattere crittografico, che potrebbero interessarti.
	</li>
	<!-- <li>
		<p>Consulta la <a routerLink="/gareCrittografiche">pagina dedicata</a>
			alle <b>gare di crittografia</b> che vengono proposte nel corso dell'anno.</p>
	</li> -->
</ul>
<hr>
<h4>SCUOLE SUPERIORI</h4>
<p>Studi alle scuole superiori e ti incuriosisce l'ambito crittografico?
	Pensi che la crittografia possa interessarti ma hai conoscenze solo
	basilari di matematica e informatica? Nessun problema, abbiamo pensato anche a te!
	La De Cifris organizza eventi e conferenze di carattere divulgativo che si prefiggono lo scopo di
	diffondere
	la crittografia al di fuori dell'ambiente universitario e aziendale. Potrebbe essere una buona
	occasione per conoscere questa materia affascinante.
</p>
<ul>
	<li>
		<p>Consulta la <a routerLink="/iniziativeDivulgative">pagina dedicata</a> alle
			iniziative divulgative e scopri quella che più fa al caso tuo.</p>
	</li>
	<li>
		<p>Consulta la <a routerLink="/gareCrittografiche">pagina dedicata</a> alle <b>gare di
				crittografia</b>
			che vengono proposte nel corso dell'anno. Non è necessaria una formazione
			universitaria per prenderne parte, né tantomeno sono richieste quote di partecipazione: sono
			gare
			aperte a chiunque abbia voglia di cimentarsi in qualcosa di motivante e istruttivo.</p>
	</li>
</ul>